(function ($) {
  if (!customElements.get('cdz-slideshow')) {
    customElements.define('cdz-slideshow', class CdzSlideshow extends HTMLElement {
      options = {}
      constructor() {
        super();
        this.element = $(this);
        this.$slider = $('[role="slider"]', this);
        this.options = $.extend(this.options, this.element.data('options'));
        var conf = this.options;
        this.slData = {
          slidesPerView: 1,
          grabCursor: true,
          lazy: true
        }
        if (conf.effect) {
          this.slData.effect = conf.effect;
        }
        if (conf.loop) {
          this.slData.loop = conf.effect;
        }
        if (conf.nav) {
          this.$slider.append('<div class="slider-btn swiper-button-prev"></div><div class="slider-btn swiper-button-next"></div>');
          this.slData.navigation = {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          }
        }
        if (conf.dots) {
          this.$slider.append('<div class="swiper-pagination"></div>');
          this.slData.pagination = {
            el: ".swiper-pagination",
            clickable: true
          }
        }
        if (conf.autoplay) {
          var delay = conf.delay ? parseInt(conf.delay) : 10000;
          this.slData.autoplay = {
            delay: delay,
            disableOnInteraction: false
          }
        }
        new Swiper(this.$slider[0], this.slData);
      }
    });
  }
})(jQuery);